import script from "./PatientsCommentsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientsCommentsList.vue?vue&type=script&setup=true&lang=js"

import "./PatientsCommentsList.vue?vue&type=style&index=0&id=41c625fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c625fe"]])

export default __exports__